import { BaseInfoContext } from '@/context/BaseInfoContext';
import { Grid } from 'antd';
import { useContext, useEffect, useState } from 'react';

/**
 * 是否应该隐藏 header
 * @returns
 */
const useShouldHideHeader = () => {
  const [{ externalContactWecomId }] = useContext(BaseInfoContext);
  const { xs } = Grid.useBreakpoint();
  const searchParams = new URLSearchParams(location.search);
  const orConditions = [
    // 小屏幕下 可以通过 query string 隐藏 header
    searchParams.get('headless') === '1' && xs,

    // 企微聊天工具栏进入环境
    Boolean(externalContactWecomId),
  ].some(Boolean);

  // 通过 querystring 强制显示
  const forceShow = new URLSearchParams(location.search).get('keephead') === '1';
  return !forceShow && orConditions;
};

/**顶部 header 展示状态 - 个别场景（如：企微），需要隐藏 */
export const useHeaderVisible = () => {
  const hideHeader = useShouldHideHeader();
  const [headerVisible, setHeaderVisible] = useState<boolean>(!hideHeader);

  useEffect(() => {
    setHeaderVisible(!hideHeader);
  }, [hideHeader]);

  return [headerVisible, setHeaderVisible] as const;
};
